import React from 'react';
import SupportEmailLink from '@/components/common/SupportEmailLink';
import translate from '@/lib/intl/translate';

export default function IntegrationHelp({ name = '' }: { name?: string }) {
  return (
    <div className="py-6 px-8 text-center type-body4 md:type-body2">
      {translate('INTEGRATIONS_TROUBLE', { name })}
      <br />
      {translate('INTEGRATIONS_CONTACT', {
        a: SupportEmailLink,
      })}
    </div>
  );
}
